import { API_ROUTES } from '@/axios'
import router, { checkToken } from '@/router'

const hasPermission = async (permission) => {
  const token = localStorage.getItem('token')
  if (!token) {
    return false
  }

  try {
    const response = await fetch(API_ROUTES.CHECK_PERMISSION(permission), {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })

    if (!response.ok) {
      const isValidToken = await checkToken()
      if (!isValidToken) {
        localStorage.removeItem('token')
        router.push('/login')
      }
      return false
    }

    const data = await response.json()
    return data.has_permission === true
  } catch (error) {
    console.error('Error checking permission:', error)
    const isValidToken = await checkToken()
    if (!isValidToken) {
      localStorage.removeItem('token')
      router.push('/login')
    }
    return false
  }
}

const getMenuItems = () => {
  const i18n = window.i18n
  return [
    'Menu',
    [
      {
        to: '/',
        icon: 'desktop-mac',
        label: i18n ? i18n.t('menu.inici') : 'Inici'
      },
      {
        to: '/xperienceiq/dashboard-client',
        label: i18n ? i18n.t('menu.dashboard') : 'Dashboard',
        icon: 'chart-line',
        permission: 'dashboard_client'
      },
      {
        to: '/xperienceiq/informes-seguiment',
        label: i18n ? i18n.t('menu.informes') : 'Informes',
        icon: 'file-chart',
        permission: 'informes_seguiment'
      }
    ]
  ]
}

// Configuration menu items (separate from main menu)
export const getConfigMenuItems = () => {
  const i18n = window.i18n
  return [
    {
      to: '/users',
      label: i18n ? i18n.t('menu.usuaris') : 'Usuaris',
      icon: 'account-group',
      permission: 'superusuari'
    },
    {
      label: i18n ? i18n.t('menu.clients') : 'Clients',
      icon: 'clipboard-account-outline',
      to: '/clients',
      permission: 'superusuari'
    },
    {
      to: '/informes-seguiment/parametres',
      label: i18n ? i18n.t('menu.parametresClients') : 'Paràmetres Clients',
      icon: 'cogs',
      permission: 'superusuari'
    },
    {
      to: '/informes-seguiment/config',
      label: i18n ? i18n.t('menu.informesConfig') : 'Informes',
      icon: 'file-chart',
      permission: 'superusuari'
    },
    {
      to: '/conexions',
      label: i18n ? i18n.t('menu.conexions') : 'Monitoritzacio',
      icon: 'monitor-dashboard',
      permission: 'superusuari'
    }
  ]
}

// Export static reference for backward compatibility
export const configMenuItems = getConfigMenuItems()

const getFilteredMenu = async () => {
  // Process menu items recursively
  const processMenuItems = async (items) => {
    const result = []
    for (const item of items) {
      // Check if current item should be displayed
      if (!item.permission || (await hasPermission(item.permission))) {
        // Create a copy of the item
        const filteredItem = { ...item }

        // If the item has a submenu, filter it recursively
        if (filteredItem.menu && filteredItem.menu.length > 0) {
          filteredItem.menu = await processMenuItems(filteredItem.menu)
          // Only include this item if it has submenu items or it has its own route
          if (filteredItem.menu.length > 0 || filteredItem.to) {
            result.push(filteredItem)
          }
        } else {
          // Item has no submenu, include it
          result.push(filteredItem)
        }
      }
    }
    return result
  }

  // Start recursive filtering with top-level items
  const menu = getMenuItems()
  const filteredTopLevel = await processMenuItems(menu[1])
  return ['', filteredTopLevel]
}

async function initializeMenu () {
  try {
    const filteredMenu = await getFilteredMenu()
    return filteredMenu
  } catch (error) {
    console.error('Error initializing menu:', error)
    return [
      []
    ]
  }
}

// Export the function rather than the Promise
export default {
  getMenu: initializeMenu
}
